import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import de from 'date-fns/locale/de';

registerLocale('de', de);
setDefaultLocale('de');

export * from './styles/react-datepicker';
export default ReactDatePicker
